import { render, staticRenderFns } from "./GeneralFilterable.vue?vue&type=template&id=0a5fbed4"
import script from "./GeneralFilterable.vue?vue&type=script&lang=ts"
export * from "./GeneralFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports